import { render, staticRenderFns } from "./DraftChangeOrdersList.vue?vue&type=template&id=d383164e"
import script from "./DraftChangeOrdersList.vue?vue&type=script&lang=js"
export * from "./DraftChangeOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports